module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAIAAAC0D9CtAAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAUElEQVR42mP8//8/A4mAiYF0MKoHj57GxkbS9DQ2NtrZO+DSxoRLAwMDAy5tjGjpYMGCBfIKisgiDx/cT0hIwKmnt7cXlx+Ki4tx2jMS0wEA3CMe2U2MS4UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/sortascbutton.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/sortascbutton.png
// module chunks = styles